module.exports = __webpack_public_path__ + "static/media/leave-room-icon.e4998891.svg";